import { httpClient } from '@/services/http/httpClient'

export type Appearance = {
  slogan?: string
  name?: string
  logo?: string
  bigLogo?: string
}

export async function getAppearance(): Promise<Appearance> {
  const { data } = await httpClient.get<Appearance>(
    '/tennants/configs/appearance',
  )

  return {
    slogan: data?.slogan,
    name: data?.name,
    logo: data?.logo,
    bigLogo: data?.bigLogo,
  }
}
